import { z } from 'zod';

// ============================================================
// Validation Schemas (Stories 4.2, 4.3)
// ============================================================

export const validationErrorSchema = z.object({
  /** The expense entry ID this error refers to (undefined for claim-level errors) */
  expenseId: z.string().optional(),
  /** 'mileage' | 'petty-cash' | 'claim' */
  expenseType: z.enum(['mileage', 'petty-cash', 'claim']),
  /** The field name that has the issue (undefined for entry-level errors) */
  field: z.string().optional(),
  /** Human-readable label used in UI (e.g. "Parking – 5 Mar") */
  expenseLabel: z.string().optional(),
  /** What is wrong */
  message: z.string(),
  /** How to fix it */
  fix: z.string(),
});

export type ValidationError = z.infer<typeof validationErrorSchema>;

export const validationErrorResponseSchema = z.object({
  code: z.literal('VALIDATION_FAILED'),
  message: z.string(),
  errors: z.array(validationErrorSchema),
});

export type ValidationErrorResponse = z.infer<typeof validationErrorResponseSchema>;
